import * as tslib_1 from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, } from '../constants';
import { getGallectionDeviationStreamId } from '../helpers';
import { getCurrentFolderId, getCurrentMediaSource, getSearchQuery, getMode, getCurrentSubfolderId, } from '../selectors';
import { MediaPopupMode, MediaSourceType } from '../types';
function handleInitGallectionDeviationStream() {
    var _a, mode, mediaSource, folderId, subfolderId, searchQuery, currentGallectionFolderId, streamId, isStreamInitialized, cacheStreams;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    mode: getMode(state),
                    mediaSource: getCurrentMediaSource(state),
                    folderId: getCurrentFolderId(state),
                    subfolderId: getCurrentSubfolderId(state),
                    searchQuery: getSearchQuery(state),
                }); })];
            case 1:
                _a = _b.sent(), mode = _a.mode, mediaSource = _a.mediaSource, folderId = _a.folderId, subfolderId = _a.subfolderId, searchQuery = _a.searchQuery;
                currentGallectionFolderId = subfolderId || folderId;
                streamId = getGallectionDeviationStreamId(mediaSource, currentGallectionFolderId, searchQuery);
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 2:
                isStreamInitialized = _b.sent();
                cacheStreams = true;
                if (searchQuery ||
                    mode === MediaPopupMode.MANAGER ||
                    mediaSource === MediaSourceType.STASH) {
                    cacheStreams = false;
                }
                if (isStreamInitialized && cacheStreams) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            groupId: MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP,
                            streamParams: {
                                mediaSource: mediaSource,
                                folderId: currentGallectionFolderId,
                                searchQuery: searchQuery,
                            },
                            itemsPerFetch: DEVIATIONS_PER_FETCH,
                            hasMore: true,
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitGallectionDeviationStream;
//# sourceMappingURL=initGallectionDeviationStream.js.map